import { render, staticRenderFns } from "./SalesRecord.vue?vue&type=template&id=16c33d43&scoped=true&"
import script from "./SalesRecord.vue?vue&type=script&lang=js&"
export * from "./SalesRecord.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecord.vue?vue&type=style&index=0&id=16c33d43&prod&lang=scss&scoped=true&"
import style1 from "./SalesRecord.vue?vue&type=style&index=1&id=16c33d43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c33d43",
  null
  
)

export default component.exports